import axios from "axios";
import { z } from "zod";

import { ContactFormData, Navigate, Schema } from "@/src/types/types";
import toast from "react-hot-toast";

const getBaseURL = (): string => {
  // Backend mutualisé pour toutes les organisations
  return process.env.REACT_APP_SERVER_URL || "http://127.0.0.1:54021";
};

export const handleSendForm = async (
  formData: ContactFormData,
  schema: Schema<ContactFormData>,
  navigate: Navigate
): Promise<string | void> => {
  try {
    schema.parse(formData);
    const baseURL = getBaseURL();
    const response = await axios.post(`${baseURL}/api/contact`, formData);
    if (response.status === 201) {
      toast.success("Votre message a été envoyé avec succès");
      return "ok";
    }
  } catch (error: any) {
    if (error instanceof z.ZodError) {
      const fieldErrors: any = {};
      error.errors.forEach((err: z.ZodIssue) => {
        fieldErrors[err.path[0]] = err.message;
      });
    } else {
      console.error("Error:", error);
      const errorMessage = error.response?.data?.message || "Une erreur est survenue";
      toast.error(errorMessage);
      return errorMessage;
    }
  }
};
